// extracted by mini-css-extract-plugin
export var background = "styles-module__background___weGDd";
export var container = "styles-module__container___gghAJ";
export var modulesContainer = "styles-module__modulesContainer___cGoW5";
export var ctaLink = "styles-module__ctaLink___nl9_h";
export var smallCtaText = "styles-module__smallCtaText___xwVL5";